import React from 'react';

import './css/SelfHosted.css'

import { Link } from 'react-router-dom';

import { ServerDiagram } from './ServerDiagram';
import { useCursorRimLight } from './rimLight';


// Where the service runs and what that buys: the diagram on one side, and on
// the other the two things said in a few words each — it is used like any
// SaaS, and it costs a lot less because it is not one.
export function SelfHosted(): React.JSX.Element {

	const gridRef = React.useRef<HTMLDivElement>( null )
	useCursorRimLight( gridRef, '.Tile' )

	return (
		<div className="Pane-Light SelfHosted" id="self-hosted" >
			<div className="Delimiter" />
			<div className="Container" >

				<div className="Section-Head" data-fade >
					<div className="Section-Kicker" >Where it runs</div>
					<div className="Title text-shadow-2" >Self-hosted API</div>
				</div>

				<div className="Section-Grid" ref={ gridRef } >

					<div className="Frame SelfHosted-Diagram" data-fade >
						<ServerDiagram />
					</div>

					<div className="Tile" data-fade data-fade-delay="0.1" >
						<div className="Tile-Title" >As simple as a SaaS</div>
						<div className="Tile-Text" >
							Run a Docker container. Make API calls.
						</div>
					</div>

					{ /* One big link to the plans, like the benchmark tile of the
					     speed section. */ }
					<Link className="Tile Tile-Link" to="/pricing" data-fade data-fade-delay="0.15" >
						<span className="Tile-Kicker" >Pricing</span>
						<span className="Tile-Title" >Much cheaper</span>
						<span className="Tile-Text SelfHosted-Link-Text" >
							No fee per image. Only an annual license.
						</span>
						<span className="Tile-Arrow" aria-hidden="true" >→</span>
					</Link>

				</div>

			</div>
		</div>
	)

}
